module.exports = __webpack_public_path__ + "img/img_serve_02@2x.8793a177.png";